import React, {useEffect, useState} from 'react';
import {DatePicker, Select, Switch, Tooltip} from "antd";
import {Line} from "@ant-design/plots";
import {API_PATH} from "../../components/const";
import dayjs from "dayjs";
import axios from "axios";
import {toast} from "react-toastify";

const VisitorsComparasion = () => {
    const [time, setTime] = useState(new Date());
    const [month, setMonth] = useState(time.getMonth());
    const [year, setYear] = useState(time.getFullYear());
    const [data, setData] = useState([]);
    const [offices, setOffices] = useState([])
    const [sendData, setSendData] = useState(null)
    const [companies, setCompanies] = useState([])
    const [show, setShow] = useState(false)
    const [parents, setParents] = useState([])
    const [filCameraList, setFilCameraList] = useState([])
    const [filSelectCamera, setSelectFilCamera] = useState([])

    const getFilCamera = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/camera/smartcamera/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": 			"Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setFilCameraList(res?.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getParentBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/sections/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": 			"Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setParents(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }

    const getBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/branch/all?hierarchy=3" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res?.data)
                asyncFetch(localStorage.getItem("com1data")?.split(',').map(Number))
            })
            .catch(() => {
                // toast.error("Ошибка")
            })
    }
    const getBuildingFilter = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/branch/all?hierarchy=3" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    function onChange(date, dateString) {
        if (dateString.length > 0) {
            setYear(dateString.slice(0, 4))
            setMonth(Number(dateString.slice(5, 7) - 1))
            axios.post(API_PATH + "company/" + localStorage.getItem('id') + "/analytics/unique-visitors/monthly-breakdown/branches?year=" + dateString.slice(0, 4) + "&month=" + Number(dateString.slice(5, 7)), companies, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then((json) => {
                        setData(json?.data)
                    }
                )
                .catch(() => {
                    // toast.error("Error")
                });
        } else {
            setYear(time.getFullYear())
            setMonth(time?.getMonth)
            asyncFetch()
        }

    }

    const asyncFetch = (data) => {
        if (!show){
            axios.post(API_PATH + "analytics/company/" + localStorage.getItem('id') + "/analytics/unique-visitors/monthly-breakdown/branches?year=" + year + "&month=" + Number(month + 1), data?.length > 0 ? {branch_ids: data, smart_camera_ids: filSelectCamera} : {branch_ids: companies,  smart_camera_ids: filSelectCamera}, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then((json) => {
                        setData(json?.data)
                    }
                )
                .catch(() => {
                    // toast.error("Error")
                });
        } else {
                axios.post(API_PATH + "analytics/company/" + localStorage.getItem('id') + "/analytics/unique-visitors-group/monthly-breakdown/branches?year=" + year + "&month=" + Number(month + 1), data?.length > 0 ? {branch_ids: data, smart_camera_ids: filSelectCamera}  :  {branch_ids: companies,  smart_camera_ids: filSelectCamera}, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then((json) => {
                        setData(json?.data)
                    }
                )
                .catch(() => {
                    // toast.error("Error")
                });
        }


    };
    const onSwitch = () => {
        setShow(!show)
        asyncFetch()
    }
    const config = {
        data,
        xField: 'date',
        yField:  'total_visitors',
        seriesField: 'branch_name',
        label: {
            style: {
                fill: 'white',
            },
        },
        point: {
            size: 5,
            shape: 'diamond',
            style: {
                fill: 'white',
                stroke: '#5B8FF9',
                lineWidth: 2,
            },
        },

        interactions: [
            {
                type: 'marker-active',
            },
        ],
        legend: {
            position: 'top',
        },

        smooth: true,
    };

    useEffect(() => {
        getBuilding()
        getParentBuilding()
        getFilCamera()
        setCompanies(localStorage.getItem("com1data")?.split(',').map(Number))
    }, [show]);
    return (
        <div>
            <div className="visitor visitor-box">
                <div className="chart-box">
                    <div className="visitor-title">
                        <h1>
                            <span className="font-family-medium">

                                {
                                    show ?
                                        "Лиды"
                                        :
                                        "Посетители"
                                }
                        </span>

                            <div className="d-flex align-items-center my-multi-select">

                                <div className="mr-16  d-flex pt-2 align-items-center">
                                    {/*<span className="text-white small-text-size mr-8">Включите, чтобы просмотреть лиды</span>*/}
                                    {/*<Switch   onChange={onSwitch}/>*/}
                                    <Tooltip placement="bottom" title="Включите, чтобы просмотреть лиды">
                                        <Switch   onChange={onSwitch}/>
                                    </Tooltip>
                                </div>

                                <div className="inputs-box mr-16 remove-back-select" >
                                    <Select
                                        showSearch
                                        placeholder="Выберите раздел"
                                        optionFilterProp="children"
                                        className="w-100"
                                        onSearch={getParentBuilding}
                                        onChange={(e) => getBuildingFilter(e)}
                                        filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                        filterSort={(optionA, optionB) =>
                                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                        }
                                        options={parents?.map((item) => {
                                            return {
                                                value: item.id,
                                                label:
                                                item?.branch_title
                                            };
                                        })}
                                    />
                                </div>

                                <div className="inputs-box   mr-16">
                                    <Select
                                        showSearch
                                        mode="multiple"
                                        placeholder="Выберите филиал"
                                        optionFilterProp="children"
                                        className="w-100"
                                        defaultValue={localStorage.getItem("com1data")?.length > 0 ? localStorage.getItem("com1data")?.split(',').map(Number) : []}
                                        onSearch={getBuilding}
                                        onChange={(e) => {
                                            setCompanies(e)
                                            localStorage.setItem("com1data", e)

                                        }}
                                        filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                        filterSort={(optionA, optionB) =>
                                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                        }
                                        options={offices?.map((item) => {
                                            return {
                                                value: item.id,
                                                label:
                                                item?.branch_title
                                            };
                                        })}
                                    />
                                </div>
                                <div className="inputs-box mr-16 " >
                                    <Select
                                        showSearch
                                        mode="multiple"
                                        placeholder="Выберите камера"
                                        optionFilterProp="children"
                                        className="w-100"
                                        onChange={(e) => setSelectFilCamera(e)}
                                        filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                        filterSort={(optionA, optionB) =>
                                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                        }
                                        options={filCameraList?.map((item) => {
                                            return {
                                                value: item.id,
                                                label:
                                                item?.name
                                            };
                                        })}
                                    />
                                </div>
                                <button style={{fontSize: "14px"}} onClick={asyncFetch}
                                        className="mr-16 mt-2 add-btn">Сравнивать
                                </button>
                                <div>
                                    <DatePicker onChange={onChange}
                                                placeholder="Выберите дату"
                                                picker="month"
                                                defaultValue={dayjs(time)}
                                    />
                                </div>

                            </div>


                        </h1>
                    </div>
                    <Line {...config} />
                </div>
            </div>
        </div>
    );
};

export default VisitorsComparasion;